import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper } from '@/util'

Vue.use(VueRouter)
// Vue.use(VueMeta)
const homePage = { name: ROUTE_NAME.HOME }
const loginGuard = function(to, from, next) {
  uiHelper.isAuthenticated() ? next() : next(homePage)
}

const testGuard = function(to, from, next) {
  next()
  // const lang = uiHelper.getRegionLocale()
  // let toFullPath = to.fullPath
  // let reg = /(en|bn)-[a-zA-Z]{2}/g
  // if(!reg.test(toFullPath)){
  //   //{domain}/{subpath}
  //   next({name:to.name})
  // }else{
  //   //{domain}/{lang}/{subpath}
  //   to.params.lang = lang
  //   next()
  // }
  console.log('test guard:' + to.path)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/home/', redirect: '/', pathToRegexpOptions: { strict: true } },
    // {
    //     path: '/home/',
    //     name: ROUTE_NAME.HOME,
    //     meta: {
    //         layout: 'layout-master',
    //     },
    //     component: () => import('@/views/home.vue'),
    //     pathToRegexpOptions: {strict: true}
    // },

    {
      path: '/sc',
      name: ROUTE_NAME.SHORTCUT,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/sc/shortcut.vue')
    },
    {
      path: '/reset-password',
      name: ROUTE_NAME.RESET_PASSWORD,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/resetPassword.vue')
    },
    {
      path: '/contact-verification',
      name: ROUTE_NAME.CONTACT_VERIFICATION,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/contactVerification.vue')
    },
    {
      path: '/register-mobile',
      name: ROUTE_NAME.REGISTER_MOBILE,
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/registerMobile.vue')
    },
    // {
    //     path: '/register',
    //     name: ROUTE_NAME.REGISTER,
    //     meta: { layout: 'layout-master' },
    //
    //     component: () => import('@/components/member/register.vue')
    // },
    // {
    //   path: '/register',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/register/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    //
    // {
    //   path: '/register/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/register/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/:lang/register',
    //   name: ROUTE_NAME.REGISTER,
    //   props: { registerErrorMsg: '', openLoginDialog: () => {}, isMobileRegistration: true },
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/defaultregister.vue'),
    //   pathToRegexpOptions: { strict: true },
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/register',
      name: ROUTE_NAME.REGISTER,
      props: { registerErrorMsg: '', openLoginDialog: () => {}, isMobileRegistration: true },
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/defaultregister.vue'),
      pathToRegexpOptions: { strict: true }
    },
    {
      path: '/:lang(en-BD|bn-BD)?/registerLanding',
      name: ROUTE_NAME.REGISTER_LANDING_PAGE,
      props: { registerErrorMsg: '', openLoginDialog: () => {}, isMobileRegistration: true },
      meta: {
        layout: 'blank-layout-master'
      },
      component: () => import('@/views/registerLandingPage.vue'),
      // component: () => import('@/views/register.vue'),
      pathToRegexpOptions: { strict: true }
    },
    // {
    //   path: '/register',
    //   name: ROUTE_NAME.REGISTER,
    //   props: { registerErrorMsg: '', openLoginDialog: () => {}, isMobileRegistration: true },
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/defaultregister.vue'),
    //   pathToRegexpOptions: { strict: true },
    //   // beforeEnter: (to, from, next) => {
    //   //   const lang = to.params.lang || '';
    //   //
    //   //   if (lang.trim() === '') {
    //   //     // If it is the ROUTE_NAME.REGISTER route and lang is empty or consists of only whitespace
    //   //     next('/register'); // Redirect to the '/register' route
    //   //   } else {
    //   //     next(); // Proceed to the route
    //   //   }
    //   // }
    // },
    {
      path: '/:lang/affiliate/referral',
      name: ROUTE_NAME.AFFILIATE_REFFERAL,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/affiliate/referral.vue')
    },
    // {
    //   path: '/sportsbook/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/sportsbook/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/sportsbook',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/sportsbook/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/sportsbook/',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/sportsbook/sportsbookLayout.vue'),
      pathToRegexpOptions: { strict: true },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/sportsbook/',
          name: ROUTE_NAME.SPORTSBOOK,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'sb' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.SPORTSBOOK_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'sb' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    // {
    //   path: '/sportsbook',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/sportsbook/sportsbookLayout.vue'),
    //   pathToRegexpOptions: { strict: true },
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.SPORTSBOOK,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'sb' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.SPORTSBOOK_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'sb' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/sportsbook',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/sportsbook`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/:lang/sportsbook/',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/sportsbook/sportsbookLayout.vue'),
    //   pathToRegexpOptions: { strict: true },
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.SPORTSBOOK,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'sb' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.SPORTSBOOK_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'sb' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/fishing',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/fishing/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/fishing/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/fishing/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/fishing',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/fishing/fishingLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/fishing');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/fishing',
          name: ROUTE_NAME.FISHING,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'fishing' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.FISHING_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'fishing' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    // {
    //   path: '/fishing',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/fishing/fishingLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.FISHING,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'fishing' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.FISHING_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'fishing' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/special',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/special/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/special/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/special/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang/special/',
      component: () => import('@/views/special/specialLayout.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/special')
        }
      },
      children: [
        {
          path: '',
          name: ROUTE_NAME.SPECIAL,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/special/special.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.SPECIAL_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/special/special.vue')
        }
      ]
    },
    // {
    //   path: '/casino',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/casino`
    //   },
    //   pathToRegexpOptions: {strict: true}
    // },
    {
      path: '/special',
      component: () => import('@/views/special/specialLayout.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.SPECIAL,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/special/special.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.SPECIAL_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/special/special.vue')
        }
      ]
    },
    // {
    //   path: '/casino',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/casino/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },

    // {
    //   path: '/casino/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/casino/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/casino',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/casino/casinoLayout.vue'),
      pathToRegexpOptions: { strict: true },
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/casino');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/casino',
          name: ROUTE_NAME.CASINO,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'ld' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.CASINO_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'ld' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },

    // {
    //   path: '/casino',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/casino/casinoLayout.vue'),
    //   pathToRegexpOptions: { strict: true },
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.CASINO,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'ld' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.CASINO_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'ld' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/slot',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/slot/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/slot/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/slot/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/slot',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/slot/slotLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/slot');
      //   }
      // },
      // params: {
      //   lang: uiHelper.getRegionLocale() // Set the lang parameter in the params object
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/slot',
          name: ROUTE_NAME.SLOT,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'rng' },
          component: () => import('@/views/slot/slot.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.SLOT_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'rng' },
          component: () => import('@/views/slot/slot.vue')
        },
        {
          path: ':provider/:gamename',
          name: ROUTE_NAME.SLOT_BY_PROVIDER_AND_GAMENAME,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'rng' },
          component: () => import('@/views/slot/slot.vue')
        },
        {
          path: 'game/:gamename',
          name: ROUTE_NAME.SLOT_BY_GAMENAME,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'rng' },
          component: () => import('@/views/slot/slot.vue')
        }
      ]
    },
    // {
    //   path: '/slot',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/slot/slotLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.SLOT,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'rng' },
    //       component: () => import('@/views/slot/slot.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.SLOT_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'rng' },
    //       component: () => import('@/views/slot/slot.vue')
    //     },
    //     {
    //       path: ':provider/:gamename',
    //       name: ROUTE_NAME.SLOT_BY_PROVIDER_AND_GAMENAME,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'rng' },
    //       component: () => import('@/views/slot/slot.vue')
    //     },
    //     {
    //       path: 'game/:gamename',
    //       name: ROUTE_NAME.SLOT_BY_GAMENAME,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'rng' },
    //       component: () => import('@/views/slot/slot.vue')
    //     }
    //   ]
    // },
    // {
    //     path: '/:lang/tablegames',
    //     component: () => import('@/views/table/tableLayout.vue'),
    //     children: [
    //         {
    //             path: '',
    //             name: ROUTE_NAME.TABLE_GAMES,
    //             meta: { layout: 'layout-master' },
    //             props: { providerSelected: 'table' },
    //             component: () => import('@/views/game/game.vue')
    //         },
    //         {
    //             path: ':provider',
    //             name: ROUTE_NAME.TABLE_GAMES_BY_PROVIDER,
    //             meta: { layout: 'layout-master' },
    //             props: { providerSelected: 'table' },
    //             component: () => import('@/views/game/game.vue')
    //         }
    //     ]
    // },
    // {
    //   path: '/tablegames',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/tablegames/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/tablegames/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/tablegames/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/tablegames',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/table/tableLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/tablegames');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/tablegames',
          name: ROUTE_NAME.TABLE_GAMES,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'table' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.TABLE_GAMES_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'table' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    // {
    //   path: '/tablegames',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/table/tableLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.TABLE_GAMES,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'table' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.TABLE_GAMES_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'table' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/lottery',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/lottery/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/lottery/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/lottery/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/lottery',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/lottery/lotteryLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/lottery');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/lottery',
          name: ROUTE_NAME.LOTTERY,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'lottery' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.LOTTERY_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'lottery' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    // {
    //   path: '/lottery',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/lottery/lotteryLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.LOTTERY,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'lottery' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.LOTTERY_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'lottery' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },

    // {
    //   path: '/crash',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/crash/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/crash/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/crash/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/crash',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/crash/crashLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/crash');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/crash',
          name: ROUTE_NAME.CRASH,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'crash' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.CRASH_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'crash' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    {
      path: '/:lang(en-BD|bn-BD)?/originals',
      meta: {
        layout: 'layout-master'
      },
      component: require('@/views/originals/originalsLayout.vue').default,
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/originals',
          name: ROUTE_NAME.ORIGINALS,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'originals' },
          component: require('@/views/game/game.vue').default
        },
        {
          path: ':provider',
          name: ROUTE_NAME.ORIGINALS_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'originals' },
          component: require('@/views/game/game.vue').default
        }
      ]
    },
    // {
    //   path: '/crash',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   component: () => import('@/views/crash/crashLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.CRASH,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'crash' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.CRASH_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'crash' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/cricket',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/cricket/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/cricket/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/cricket/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/cricket',
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/cricket/cricketLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/cricket');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/cricket',
          name: ROUTE_NAME.CRICKET,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'cricket' },
          component: () => import('@/views/game/game.vue')
        },
        {
          path: ':provider',
          name: ROUTE_NAME.CRICKET_BY_PROVIDER,
          meta: { layout: 'layout-master' },
          props: { providerSelected: 'cricket' },
          component: () => import('@/views/game/game.vue')
        }
      ]
    },
    // {
    //   path: '/cricket',
    //   meta: {
    //     layout: 'layout-master'
    //   },
    //   // beforeEnter: (to, from, next) => {
    //   //   // testGuard(to,from,next)
    //   // },
    //   component: () => import('@/views/cricket/cricketLayout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.CRICKET,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'cricket' },
    //       component: () => import('@/views/game/game.vue')
    //     },
    //     {
    //       path: ':provider',
    //       name: ROUTE_NAME.CRICKET_BY_PROVIDER,
    //       meta: { layout: 'layout-master' },
    //       props: { providerSelected: 'cricket' },
    //       component: () => import('@/views/game/game.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/playgame/:provider/:type',
      name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/game/play.vue')
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/playgame/:provider/:type');
      //   }
      // }
    },
    // {
    //   path: '/playgame/:provider/:type',
    //   name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
    //   meta: { layout: 'blank-layout-master' },
    //   component: () => import('@/views/game/play.vue')
    // },
    {
      path: '/:lang/deposit_vendor',
      name: ROUTE_NAME.VENDOR_POPUP,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/vendorPopUp.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/deposit_vendor')
        }
      }
    },
    {
      path: '/deposit_vendor',
      name: ROUTE_NAME.VENDOR_POPUP,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/vendorPopUp.vue')
    },
    // {
    //   path: '/funds',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/bank/funds/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/:lang/bank',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/bank/bankLayout.vue'),
    //   beforeEnter: (to, from, next) => {
    //     loginGuard(to, from, next)
    //     const { params } = to;
    //
    //     if (params.lang) {
    //       // Proceed to the route
    //       next();
    //     } else {
    //       // Redirect to the /register path
    //       next('/bank');
    //     }
    //   },
    //   children: [
    //     {
    //       path: 'funds',
    //       name: ROUTE_NAME.FUNDS,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/bank/funds.vue')
    //     },
    //     // {
    //     //     path: 'deposit',
    //     //     name: ROUTE_NAME.DEPOSIT,
    //     //     meta: {layout: 'layout-master'},
    //     //     component: () => import('@/views/bank/deposit.vue'),
    //     // },
    //     {
    //       path: 'deposit-success',
    //       name: ROUTE_NAME.DEPOSIT_SUCCESS,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/bank/depositSuccess.vue')
    //     },
    //     // {
    //     //     path: 'withdrawal',
    //     //     name: ROUTE_NAME.WITHDRAWAL,
    //     //     meta: {layout: 'layout-master'},
    //     //     component: () => import('@/views/bank/withdrawal.vue'),
    //     // },
    //     {
    //       path: 'transaction',
    //       name: ROUTE_NAME.TRANSACTION,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/bank/transaction.vue')
    //     },
    //     {
    //       path: 'voucher',
    //       name: ROUTE_NAME.CLAIM_VOUCHER,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/bank/claimVoucher.vue')
    //     },
    //     {
    //       path: 'transfer',
    //       name: ROUTE_NAME.TRANSFER,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/bank/transfer.vue')
    //     },
    //     {
    //       path: 'vip',
    //       name: ROUTE_NAME.VIP_PROFILE,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/vipPage.vue')
    //     },
    //     {
    //       path: 'transfer-history',
    //       name: ROUTE_NAME.TRANSFER_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/transactionHistory.vue')
    //     },
    //     {
    //       path: 'betting-history',
    //       name: ROUTE_NAME.BETTING_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/history/historyOverview.vue')
    //     },
    //     {
    //       path: 'turnover-history',
    //       name: ROUTE_NAME.TURNOVER_RECORD,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/turnover/historyOverview.vue')
    //     },
    //     {
    //       path: 'transaction-history',
    //       name: ROUTE_NAME.TRANSACTION_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/transactionHistory.vue')
    //     },
    //     {
    //       path: 'bonus-history',
    //       name: ROUTE_NAME.BONUS_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/transactionHistory.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/bank',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/bank/bankLayout.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
      },
      children: [
        {
          path: 'funds',
          name: ROUTE_NAME.FUNDS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/funds.vue')
        },
        {
          path: 'deposit',
          name: ROUTE_NAME.DEPOSIT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/deposit.vue')
        },
        {
          path: 'deposit-success',
          name: ROUTE_NAME.DEPOSIT_SUCCESS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/depositSuccess.vue')
        },
        // {
        //     path: 'withdrawal',
        //     name: ROUTE_NAME.WITHDRAWAL,
        //     meta: {layout: 'layout-master'},
        //     component: () => import('@/views/bank/withdrawal.vue'),
        // },
        {
          path: 'transaction',
          name: ROUTE_NAME.TRANSACTION,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/transaction.vue')
        },
        {
          path: 'voucher',
          name: ROUTE_NAME.CLAIM_VOUCHER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/claimVoucher.vue')
        },
        {
          path: 'transfer',
          name: ROUTE_NAME.TRANSFER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/bank/transfer.vue')
        },
        {
          path: 'vip',
          name: ROUTE_NAME.VIP_PROFILE,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/vipPage.vue')
        },
        {
          path: 'transfer-history',
          name: ROUTE_NAME.TRANSFER_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/transactionHistory.vue')
        },
        {
          path: 'betting-history',
          name: ROUTE_NAME.BETTING_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/history/historyOverview.vue')
        },
        {
          path: 'turnover-history',
          name: ROUTE_NAME.TURNOVER_RECORD,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/turnover/historyOverview.vue')
        },
        {
          path: 'transaction-history',
          name: ROUTE_NAME.TRANSACTION_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/transactionHistory.vue')
        },
        {
          path: 'bonus-history',
          name: ROUTE_NAME.BONUS_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/transactionHistory.vue')
        }
      ]
    },
    {
      path: '/:lang/payment/process',
      name: ROUTE_NAME.PROCESS_TRANSACTION,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/process.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/payment/process')
        }
      }
    },
    {
      path: '/payment/process',
      name: ROUTE_NAME.PROCESS_TRANSACTION,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/process.vue')
    },
    {
      path: '/:lang/payment/pay-secure',
      name: ROUTE_NAME.PAY_SECURE,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/paysecure.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/payment/pay-secure')
        }
      }
    },
    {
      path: '/payment/pay-secure',
      name: ROUTE_NAME.PAY_SECURE,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/bank/paysecure.vue')
    },
    {
      path: '/:lang/profile/menu',
      name: ROUTE_NAME.PROFILE_MENU,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/menu.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/profile/menu')
        }
      }
    },
    {
      path: '/profile/menu',
      name: ROUTE_NAME.PROFILE_MENU,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/menu.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
      }
    },
    {
      path: '/:lang/profile/logout',
      name: ROUTE_NAME.PROFILE_LOGOUT,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/logout.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/profile/logout')
        }
      }
    },
    {
      path: '/profile/logout',
      name: ROUTE_NAME.PROFILE_LOGOUT,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/logout.vue')
    },
    {
      path: '/:lang(en-BD|bn-BD)?/profile',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/profileLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   loginGuard(to, from, next)
      // const { params } = to
      //
      // if (params.lang) {
      //   loginGuard(to, from, next)
      //   // Proceed to the route
      //   next();
      // } else {
      //   loginGuard(to, from, next)
      //   // Redirect to the /register path
      //   next('/profile');
      // }
      // },
      children: [
        {
          path: 'agent/apply',
          name: ROUTE_NAME.APPLY_AGENT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/applyAgent.vue')
        },
        { path: '/agent/apply', redirect: '/profile/agent/apply', pathToRegexpOptions: { strict: true } }
      ]
    },
    // {
    //   path: '/profile',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/profile/profileLayout.vue'),
    //   children: [
    //     {
    //       path: 'agent/apply',
    //       name: ROUTE_NAME.APPLY_AGENT,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/applyAgent.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/profile',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/profileLayout.vue'),
      beforeEnter: (to, from, next) => {
        // const { params } = to;
        loginGuard(to, from, next)
        // if (params.lang) {
        //   // Proceed to the route
        //   next();
        // } else {
        //   // Redirect to the /register path
        //   next('/profile');
        // }
      },
      children: [
        {
          path: 'account',
          name: ROUTE_NAME.PROFILE,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/account.vue')
        },
        {
          path: 'personal',
          name: ROUTE_NAME.PERSONAL,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/personal.vue')
        },
        {
          path: 'message',
          name: ROUTE_NAME.ANNOUNCEMENT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/announcement.vue')
        },
        {
          path: 'change-password',
          name: ROUTE_NAME.CHANGE_PASSWORD,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/changePassword.vue')
        },
        {
          path: 'bank-account',
          name: ROUTE_NAME.BANK_ACCOUNT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/bankAccount.vue')
        },
        {
          path: 'inbox',
          name: ROUTE_NAME.INBOX,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/inbox.vue')
        },
        {
          path: 'rewards',
          name: ROUTE_NAME.REWARDS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/rewards.vue')
        }
      ]
    },
    // {
    //   path: '/profile',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/profile/profileLayout.vue'),
    //   beforeEnter: (to, from, next) => {
    //     loginGuard(to, from, next)
    //   },
    //   children: [
    //     {
    //       path: 'account',
    //       name: ROUTE_NAME.PROFILE,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/account.vue')
    //     },
    //     {
    //       path: 'personal',
    //       name: ROUTE_NAME.PERSONAL,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/personal.vue')
    //     },
    //     {
    //       path: 'message',
    //       name: ROUTE_NAME.ANNOUNCEMENT,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/announcement.vue')
    //     },
    //     {
    //       path: 'change-password',
    //       name: ROUTE_NAME.CHANGE_PASSWORD,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/changePassword.vue')
    //     },
    //     {
    //       path: 'bank-account',
    //       name: ROUTE_NAME.BANK_ACCOUNT,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/bankAccount.vue')
    //     },
    //     {
    //       path: 'inbox',
    //       name: ROUTE_NAME.INBOX,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/inbox.vue')
    //     },
    //     {
    //       path: 'rewards',
    //       name: ROUTE_NAME.REWARDS,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/rewards.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/rewards/instantRebate',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/rewards/instantRebate/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/rewards/instantRebate/rebateHistory',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/rewards/rebateHistory/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang/rewards/instantRebate',
      name: ROUTE_NAME.REBATE,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/instantRebate.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/rewards/instantRebate')
        }
      }
    },
    {
      path: '/rewards/instantRebate',
      name: ROUTE_NAME.REBATE,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/instantRebate.vue')
    },
    {
      path: '/:lang/rewards/instantRebate',
      name: ROUTE_NAME.REBATE,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/instantRebate.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/rewards/instantRebate')
        }
      }
    },
    // {
    //   path: '/rewards/instantRebate',
    //   name: ROUTE_NAME.REBATE,
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/rewards/instantRebate.vue'),
    // },
    {
      path: '/:lang/dailycheckin',
      name: ROUTE_NAME.DAILYCHECKIN,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/dailycheckin.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/dailycheckin')
        }
      }
    },
    {
      path: '/dailycheckin',
      name: ROUTE_NAME.DAILYCHECKIN,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/dailycheckin.vue')
    },
    {
      path: '/:lang/rewards/rebateHistory',
      name: ROUTE_NAME.REBATE_HISTORY,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/rebateHistory.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/rewards/rebateHistory')
        }
      }
    },
    {
      path: '/rewards/rebateHistory',
      name: ROUTE_NAME.REBATE_HISTORY,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/rebateHistory.vue')
    },
    {
      path: '/:lang/rewards/rebateHistoryDetail',
      name: ROUTE_NAME.REBATE_HISTORY_DETAIL,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/rebateHistoryDetail.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/rewards/rebateHistoryDetail')
        }
      }
    },
    {
      path: '/rewards/rebateHistoryDetail',
      name: ROUTE_NAME.REBATE_HISTORY_DETAIL,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/rebateHistoryDetail.vue')
    },
    {
      path: '/:lang/daily-checkin',
      name: ROUTE_NAME.DAILY_CHECKIN,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/rewards.vue'),
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/daily-checkin')
        }
      }
    },
    {
      path: '/daily-checkin',
      name: ROUTE_NAME.DAILY_CHECKIN,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/profile/rewards.vue')
    },
    {
      path: '/:lang(en-BD|bn-BD)?/voucher',
      name: ROUTE_NAME.CLAIM_VOUCHER,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/bank/claimVoucher.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
      }
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/bank/voucher');
      //   }
      // },
    },
    // {
    //   path: '/bank/voucher',
    //   name: ROUTE_NAME.CLAIM_VOUCHER,
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/bank/claimVoucher.vue'),
    // },
    // {
    //     path: '/rewards',
    //     meta: {layout: 'layout-master'},
    //     component: () => import('@/views/rewards/rewardLayout.vue'),
    //     children: [
    //         {
    //             path: ':type',
    //             name: ROUTE_NAME.REWARDS_BY_TYPE,
    //             meta: {layout: 'layout-master'},
    //             component: () => import('@/views/rewards/rewards.vue'),
    //         }
    //     ]
    // },
    // {
    //   path: '/promotion',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/promotion/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    // {
    //   path: '/promotion/',
    //   redirect: () => {
    //     const lang = uiHelper.getRegionLocale() // Get the language code
    //
    //     return `/${lang}/promotion/`
    //   },
    //   pathToRegexpOptions: { strict: true }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/promotion',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/promotion/promotionLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/promotion');
      //   }
      // },
      children: [
        {
          path: '/:lang(en-BD|bn-BD)?/promotion',
          name: ROUTE_NAME.PROMOTION,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/promotion/promotion.vue')
        },
        {
          path: 'in-progress',
          name: ROUTE_NAME.PROMOTION_IN_PROGRESS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/promotion/inprogress.vue'),
          beforeEnter: (to, from, next) => {
            loginGuard(to, from, next)
          }
        },
        {
          path: 'history',
          name: ROUTE_NAME.PROMOTION_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/promotion/history.vue'),
          beforeEnter: (to, from, next) => {
            loginGuard(to, from, next)
          }
        }
      ]
    },
    // {
    //   path: '/promotion',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/promotion/promotionLayout.vue'),
    //   children: [
    //     {
    //       path: '/',
    //       name: ROUTE_NAME.PROMOTION,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/promotion/promotion.vue')
    //     },
    //     {
    //       path: 'in-progress',
    //       name: ROUTE_NAME.PROMOTION_IN_PROGRESS,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/promotion/inprogress.vue'),
    //       beforeEnter: (to, from, next) => {
    //         loginGuard(to, from, next)
    //       }
    //     },
    //     {
    //       path: 'history',
    //       name: ROUTE_NAME.PROMOTION_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/promotion/history.vue'),
    //       beforeEnter: (to, from, next) => {
    //         loginGuard(to, from, next)
    //       }
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/info',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/info/infoLayout.vue'),
      children: [
        {
          path: 'faq',
          name: ROUTE_NAME.FAQ,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/info/faq.vue')
        },
        {
          path: 'about-us',
          name: ROUTE_NAME.ABOUT_US,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/info/aboutUs.vue')
        },
        {
          path: 'contact-us',
          name: ROUTE_NAME.CONTACT_US,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/info/contactUs.vue')
        },
        {
          path: 'tnc',
          name: ROUTE_NAME.TNC,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/info/tnc.vue')
        }
      ]
    },
    {
      path: '/:lang/affiliate/home',
      name: ROUTE_NAME.AFFILIATE_HOME,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/affiliate/home.vue')
    },
    {
      path: '/:lang/affiliate',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/affiliate/affiliateLayout.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
      },
      children: [
        {
          path: 'members',
          name: ROUTE_NAME.AFFILIATE_MEMBER_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliate/memberReport.vue')
        },
        {
          path: 'members-detail',
          name: ROUTE_NAME.AFFILIATE_MEMBER_DETAIL_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliate/memberDetailReport.vue')
        },
        {
          path: 'games-report',
          name: ROUTE_NAME.AFFILIATE_GAME_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliate/gameReport.vue')
        },
        {
          path: 'agent-report',
          name: ROUTE_NAME.AFFILIATE_AGENT_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliate/agentReport.vue')
        },
        {
          path: 'link',
          name: ROUTE_NAME.AFFILIATE_LINK,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliate/link.vue')
        }
      ]
    },
    {
      path: '/:lang/affiliate/bank',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/affiliatePayment/bankLayout.vue'),
      beforeEnter: (to, from, next) => {
        loginGuard(to, from, next)
      },
      children: [
        {
          path: 'withdrawal',
          name: ROUTE_NAME.AFFILIATE_WITHDRAWAL,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliatePayment/withdrawal.vue')
        },
        {
          path: 'transaction',
          name: ROUTE_NAME.AFFILIATE_TRANSACTION,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliatePayment/transaction.vue')
        },
        {
          path: 'account',
          name: ROUTE_NAME.AFFILIATE_BANK_ACCOUNT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/affiliatePayment/account.vue')
        }
      ]
    },
    // {
    //   path: '/:lang/nspin/',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/rewards/WheelOfFortune.vue'),
    //   name: ROUTE_NAME.WOF,
    //   beforeEnter: (to, from, next) => {
    //     const { params } = to;
    //
    //     if (params.lang) {
    //       // Proceed to the route
    //       next();
    //     } else {
    //       // Redirect to the /register path
    //       next('/nspin');
    //     }
    //   }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/nspin',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/WheelOfFortune.vue'),
      name: ROUTE_NAME.WOF
    },
    // {
    //   path: '/:lang/mnspin/',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/rewards/MobileWheelOfFortune.vue'),
    //   name: ROUTE_NAME.MWOF,
    //   beforeEnter: (to, from, next) => {
    //     const { params } = to;
    //
    //     if (params.lang) {
    //       // Proceed to the route
    //       next();
    //     } else {
    //       // Redirect to the /register path
    //       next('/mnspin');
    //     }
    //   }
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/mnspin',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/MobileWheelOfFortune.vue'),
      name: ROUTE_NAME.MWOF
    },
    {
      path: '/:lang/grab-coin',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/GrabCoin.vue'),
      name: ROUTE_NAME.GRAB_COIN,
      beforeEnter: (to, from, next) => {
        const { params } = to

        if (params.lang) {
          // Proceed to the route
          next()
        } else {
          // Redirect to the /register path
          next('/grab-coin')
        }
      }
    },
    {
      path: '/grab-coin',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/rewards/GrabCoin.vue'),
      name: ROUTE_NAME.GRAB_COIN
    },
    {
      path: '/:lang(en-BD|bn-BD)?/referral',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/referral/referralLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/referral');
      //   }
      // },
      children: [
        {
          path: 'tier',
          name: ROUTE_NAME.REFERRAL_TIER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/referralTier.vue')
        },
        {
          path: 'summary',
          name: ROUTE_NAME.REFERRAL_SUMMARY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/referralSummary.vue')
        },
        {
          path: 'report',
          name: ROUTE_NAME.REFERRAL_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/referralReport.vue')
        },
        {
          path: 'downlinereport',
          name: ROUTE_NAME.REFERRAL_DOWNLINE_REPORT,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/downlineReport.vue')
        },
        {
          path: 'status',
          name: ROUTE_NAME.REFERRAL_STATUS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/status.vue')
        },
        {
          path: 'history',
          name: ROUTE_NAME.REFERRAL_HISTORY,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/referral/referralHistory.vue')
        }
      ]
    },
    // {
    //   path: '/referral',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/referral/referralLayout.vue'),
    //   children: [
    //     {
    //       path: 'tier',
    //       name: ROUTE_NAME.REFERRAL_TIER,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/referral/referralTier.vue')
    //     },
    //     {
    //       path: 'summary',
    //       name: ROUTE_NAME.REFERRAL_SUMMARY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/referral/referralSummary.vue')
    //     },
    //     {
    //       path: 'report',
    //       name: ROUTE_NAME.REFERRAL_REPORT,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/referral/referralReport.vue')
    //     },
    //     {
    //       path: 'history',
    //       name: ROUTE_NAME.REFERRAL_HISTORY,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/referral/referralHistory.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/viptiers',
      meta: { layout: 'layout-master' },
      // name: ROUTE_NAME.VIPTIER,
      component: () => import('@/views/viptiers/viptier.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/vip-tier');
      //   }
      // },
      children: [
        {
          path: 'vip-tier',
          name: ROUTE_NAME.VIPTIER,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/viptiers/viptier.vue')
        }
      ]
    },
    // {
    //   path: '/viptiers',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/viptiers/viptier.vue'),
    //
    //   children: [
    //     {
    //       path: 'vip-tier/',
    //       name: ROUTE_NAME.VIPTIER,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/viptiers/viptier.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/referral',
      meta: { layout: 'layout-master' },
      component: () => import('@/views/bank/bankLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/referral');
      //   }
      // },
      children: [
        {
          path: 'bonus/',
          name: ROUTE_NAME.REFERRAL_BONUS,
          meta: { layout: 'layout-master' },
          component: () => import('@/views/profile/affiliateBonus.vue')
        }
      ]
    },
    // {
    //   path: '/referral',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/bank/bankLayout.vue'),
    //   children: [
    //     {
    //       path: 'bonus/',
    //       name: ROUTE_NAME.REFERRAL_BONUS,
    //       meta: { layout: 'layout-master' },
    //       component: () => import('@/views/profile/affiliateBonus.vue')
    //     }
    //   ]
    // },
    {
      path: '/:lang(en-BD|bn-BD)?/nagad88Ladderboard/challenge',
      // redirect: ROUTE_NAME.PAGE_NOT_AVAILABLE
      redirect: '/pageNotAvailable'
    },
    // {
    //   path: '/:lang(en-BD|bn-BD)?/nagad88Ladderboard',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/vip/vipLayout.vue'),
    //   children: [
    //     {
    //       path: 'challenge',
    //       name: ROUTE_NAME.VIP,
    //       meta: {
    //         layout: 'layout-master'
    //       },
    //       component: () => import('@/views/vip/vip.vue'),
    //       pathToRegexpOptions: { strict: true }
    //     },
    //     { path: 'challenge/', redirect: 'challenge', pathToRegexpOptions: { strict: true } }
    //   ]
    // },
    // {
    //   path: '/nagad88Ladderboard',
    //   meta: { layout: 'layout-master' },
    //   component: () => import('@/views/vip/vipLayout.vue'),
    //   children: [
    //     {
    //       path: 'challenge/',
    //       name: ROUTE_NAME.VIP,
    //       meta: {
    //         layout: 'layout-master'
    //       },
    //       component: () => import('@/views/vip/vip.vue'),
    //       pathToRegexpOptions: { strict: true }
    //     },
    //     { path: 'challenge', redirect: 'challenge/', pathToRegexpOptions: { strict: true } }
    //   ]
    // },
    {
      path: '/pageNotAvailable',
      name: ROUTE_NAME.PAGE_NOT_AVAILABLE,
      meta: { layout: 'blank-layout-master' },
      component: () => import('@/views/notAvailablePage.vue')
    },
    {
      path: '/:lang(en-BD|bn-BD)?/error',
      component: () => import('@/views/error/errorLayout.vue'),
      // beforeEnter: (to, from, next) => {
      //   const { params } = to;
      //
      //   if (params.lang) {
      //     // Proceed to the route
      //     next();
      //   } else {
      //     // Redirect to the /register path
      //     next('/error');
      //   }
      // },
      children: [
        {
          path: 'ip-restriction',
          name: ROUTE_NAME.ERROR_403,
          meta: { layout: 'blank-layout-master' },
          component: () => import('@/views/error/403.vue')
        },
        {
          path: 'page-not-found/',
          name: ROUTE_NAME.ERROR_404,
          meta: { layout: 'blank-layout-master' },
          component: () => import('@/views/error/404.vue')
        }
      ]
    },
    // {
    //   path: '/error',
    //   component: () => import('@/views/error/errorLayout.vue'),
    //   children: [
    //     {
    //       path: 'ip-restriction',
    //       name: ROUTE_NAME.ERROR_403,
    //       meta: { layout: 'blank-layout-master' },
    //       component: () => import('@/views/error/403.vue')
    //     },
    //     {
    //       path: 'page-not-found/',
    //       name: ROUTE_NAME.ERROR_404,
    //       meta: { layout: 'blank-layout-master' },
    //       component: () => import('@/views/error/404.vue')
    //     }
    //   ]
    // },
    { path: '/home', redirect: '/', pathToRegexpOptions: { strict: true } },
    {
      path: ['/:lang(en-BD|bn-BD)?'],
      alias: '/:lang/home',
      name: ROUTE_NAME.HOME,
      meta: {
        layout: 'layout-master'
      },
      component: () => import('@/views/home.vue'),
      pathToRegexpOptions: { strict: true }
      // beforeEnter: (to, from, next) => {
      //   const lang = uiHelper.getRegionLocale()
      //   to.params.lang = lang
      //   next()
      // },
      // beforeEnter: (to, from, next) => {
      //   // testGuard(to,from,next)
      // }
    },
    {
      path: '/',
      name: ROUTE_NAME.HOME,
      meta: { layout: 'layout-master' },
      component: () => import('@/views/home.vue')
      // beforeEnter: (to, from, next) => {
      //   // testGuard(to,from,next)
      // }
    },
    // { path: '/', redirect: ROUTE_NAME.HOME, pathToRegexpOptions: { strict: true } },
    {
      path: '*',
      redirect: { name: ROUTE_NAME.ERROR_404 }
    }
  ],
  /* TO AUTO BACK TO TOP */
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})
export default router
